import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private auth: AuthService) {}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let _zf_token = this.auth._zf_tokenValue;
        if (_zf_token) {
            if (request.url.indexOf("http://api.ipify.org") > -1) {
                
            }
            else{
                request = request.clone({
                    setHeaders: { 
                        Authorization: `Bearer ${_zf_token}`
                    }
                });
            }
            
        }
        return next.handle(request);
    }
}